var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39844 3.99961C5.95661 3.99961 5.59844 4.35778 5.59844 4.79961C5.59844 5.24144 5.95661 5.59961 6.39844 5.59961L10.8671 5.59961L9.83275 6.63392C9.52033 6.94634 9.52033 7.45288 9.83275 7.76529C10.1452 8.07771 10.6517 8.07771 10.9641 7.7653L13.3641 5.3653C13.5142 5.21527 13.5984 5.01178 13.5984 4.79961C13.5984 4.58744 13.5142 4.38395 13.3641 4.23392L10.9641 1.83392C10.6517 1.5215 10.1452 1.5215 9.83275 1.83392C9.52033 2.14634 9.52033 2.65288 9.83275 2.96529L10.8671 3.99961L6.39844 3.99961Z",
    fill: "#64748B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59844 11.9996C10.0403 11.9996 10.3984 11.6414 10.3984 11.1996C10.3984 10.7578 10.0403 10.3996 9.59844 10.3996L5.12981 10.3996L6.16412 9.36529C6.47654 9.05288 6.47654 8.54634 6.16412 8.23392C5.8517 7.9215 5.34517 7.9215 5.03275 8.23392L2.63275 10.6339C2.48272 10.784 2.39844 10.9874 2.39844 11.1996C2.39844 11.4118 2.48272 11.6153 2.63275 11.7653L5.03275 14.1653C5.34517 14.4777 5.8517 14.4777 6.16412 14.1653C6.47654 13.8529 6.47654 13.3463 6.16412 13.0339L5.12981 11.9996H9.59844Z",
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchHorizontal);
export default __webpack_public_path__ + "static/media/SwitchHorizontal.d21d2e633af282c0d3fb3c06659fa7f8.svg";
export { ForwardRef as ReactComponent };